import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from '@rappi/rests-commons-front';
import { I18nextProvider } from 'react-i18next';
import { SWRConfig } from 'swr';
import i18nInstance from '../../translates/i18n';
export const BaseProvider = ({ children }) => (
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
_jsx(ThemeProvider, { theme: "ligth", children: _jsx(SWRConfig, { children: _jsx(I18nextProvider, { i18n: i18nInstance, children: children }) }) }, "theme-provider-hunter-tools"));
